
import Header from "./header";
import "../App.css";
import "./brain.css";
import moment from "moment";
import { ethers } from "ethers";
import ReactPlayer from 'react-player';
import { toWei } from "thirdweb/utils";
import { FaLock } from "react-icons/fa";
import { HexColorPicker } from 'react-colorful';
import {useLocation, Link} from "react-router-dom";
// import * as s from "./styles/globalStyles";
import { BsShieldLock } from "react-icons/bs"; 
import { PiInfinityLight } from "react-icons/pi"; 
import { PiSealWarningDuotone } from "react-icons/pi";
import { useMediaQuery } from 'react-responsive';
import { instructions, bgmusic, soundeffects, contracts } from '../tools/effects';
import { ethers5Adapter } from "thirdweb/adapters/ethers5";
import React, { useEffect, useState, useRef, createRef } from "react";
import { createWallet, walletConnect, inAppWallet } from "thirdweb/wallets";
import { formatNumber, removeThousands, truncateAddress } from '../tools/utils';
import { createThirdwebClient, getContract, sendTransaction, readContract, prepareContractCall, prepareEvent} from "thirdweb";
import { GiZeusSword, Gi3dHammer, GiEyeTarget, GiConsoleController, GiWarPick, GiTrophyCup, GiLaurelsTrophy, GiStarMedal, GiWallet} from "react-icons/gi"; 
import { ThirdwebProvider, ConnectButton, darkTheme, useConnect, useActiveAccount, useReadContract, useActiveWallet,
  useActiveWalletChain, useSwitchActiveWalletChain, useSendTransaction, useWalletBalance, useContractEvents } from "thirdweb/react";
import { defineChain } from "thirdweb/chains";
import Robot from "./robot";
import {networkDataArray} from "../tools/networkData";
import { useSelector } from 'react-redux';
import { selectBlockchain, selectNetworkIndex, chains } from '../redux/reducers/networkReducer';

// Media Screen Resolution *************************************************************************************************
export const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return isMobile ? children : null;
}; 

let account;

// Utils **************************************************************************************************************

export const rpcUrl = [networkDataArray[0].rpc, networkDataArray[1].rpc, networkDataArray[2].rpc, networkDataArray[3].rpc];
export const network = [defineChain({ id: networkDataArray[0].chainId, rpc: rpcUrl[0]}), defineChain({ id: networkDataArray[1].chainId, rpc: rpcUrl[1]}), 
  defineChain({ id: networkDataArray[2].chainId, rpc: rpcUrl[2]}), defineChain({ id: networkDataArray[3].chainId, rpc: rpcUrl[3]})]; 
export const brainAddresses = [networkDataArray[0].brainaddress, networkDataArray[1].brainaddress, networkDataArray[2].brainaddress,
  networkDataArray[3].brainaddress];
export const brainNFTaddresses = [networkDataArray[0].brainNFTaddress, networkDataArray[1].brainNFTaddress, networkDataArray[2].brainNFTaddress,
  networkDataArray[3].brainNFTaddress]; 

const ethersProvider0 = new ethers.providers.JsonRpcProvider(rpcUrl[0]);
const ethersProvider1 = new ethers.providers.JsonRpcProvider(rpcUrl[1]);
const ethersProvider2 = new ethers.providers.JsonRpcProvider(rpcUrl[2]);
const ethersProvider3 = new ethers.providers.JsonRpcProvider(rpcUrl[3]);
export const ethersProviders = [ethersProvider0, ethersProvider1, ethersProvider2, ethersProvider3];

const contractEthersBrainNFT0 = new ethers.Contract(brainNFTaddresses[0], contracts.BrainsNFT.abi, ethersProvider0);
const contractEthersBrainNFT1 = new ethers.Contract(brainNFTaddresses[1], contracts.BrainsNFT.abi, ethersProvider1);
const contractEthersBrainNFT2 = new ethers.Contract(brainNFTaddresses[2], contracts.BrainsNFT.abi, ethersProvider2);
const contractEthersBrainNFT3 = new ethers.Contract(brainNFTaddresses[3], contracts.BrainsNFT.abi, ethersProvider3);
export const contractEthersBrainNFTs = [contractEthersBrainNFT0, contractEthersBrainNFT1, contractEthersBrainNFT2, contractEthersBrainNFT3];

export const donationAddress = '0x8B40FC00D483b8A6A31539BbB399B14e1d36E454';

export const StreamText = ({ text, delay_const = 4000 }) => {
  const [displayText, setDisplayText] = useState('');
  const animationFrameRef = useRef(null);
  const startTimeRef = useRef(null);
  const currentIndexRef = useRef(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!text) {
      setDisplayText(''); // Reset displayText if text is undefined
      return;
    }

    // Reset state when text changes
    setDisplayText('');
    currentIndexRef.current = 0;
    startTimeRef.current = null;

    const renderText = (timestamp) => {
      if (!startTimeRef.current) {
        startTimeRef.current = timestamp; // Initialize start time
      }

      const elapsedTime = timestamp - startTimeRef.current;
      const intervalTime = 4000 / text.length; // Time per character
      const charactersToRender = Math.floor(elapsedTime / intervalTime);

      if (charactersToRender > currentIndexRef.current && charactersToRender <= text.length) {
        setDisplayText(text.slice(0, charactersToRender));
        currentIndexRef.current = charactersToRender;
      }

      if (currentIndexRef.current < text.length) {
        animationFrameRef.current = requestAnimationFrame(renderText);
      }
    };

    // Clear any existing timeout to avoid multiple timeouts
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set a timeout to delay the start of the animation
    timeoutRef.current = setTimeout(() => {
      animationFrameRef.current = requestAnimationFrame(renderText);
    }, delay_const);

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current); // Cleanup animation frame
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current); // Cleanup timeout
      }
    };
  }, [text, delay_const]);

  return <div style={{ whiteSpace: 'pre-wrap' }}>{displayText}</div>;
};

export const injectDate = (text) => {
  const now = new Date();
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZoneName: 'shortOffset',
  };
  const formattedDate = now.toLocaleString('en-US', options);
  const stampedEssay = `DATE: ${formattedDate} \n\n ` + text;
  return stampedEssay;
}

export const parseResponse = async (text) => {
  if (!text) return '';
  const headers = ['INSIGHT:', 'LIST:', 'ACTIONS:', 'DISCLAIMER:', 'ADVICE:', 'CONTACTS:'];
  const result = {
    insight: '',
    list: '',
    actions: '',
    disclaimer: '',
    advice: '',
    contacts: '',
  };

  headers.forEach((header) => {
    // Create a regex pattern to match the header and its content
    const regex = new RegExp(`${header}([\\s\\S]*?)(?=${headers.join('|')}|$)`, 'i');
    const match = text.match(regex);

    if (match) {
      let content = match[1].trim(); // Extract and trim content

      // Add "🧠 " prefix for non-LIST and non-CONTACTS headers
      if (header !== 'LIST:' && header !== 'CONTACTS:') {
        content = '🧠 ' + content;
      }

      // Map the header to the result object key (remove the colon and convert to lowercase)
      const key = header.toLowerCase().replace(':', '');
      result[key] = content;
    }
  });

  return result;
};

export function dateExtractor(_dialogueArray) {
  const header = 'DATE:'; 
  const result = []; 

  // Loop through each entry in the _dialogueArray
  _dialogueArray.forEach((text) => {
    // Create a regex pattern to match the header and its content, stopping at double line breaks
    const regex = new RegExp(`${header}([\\s\\S]*?)(\\n\\n|$)`, 'g');
    const match = text.match(regex);

    if (match) {
      // Extract and trim the content after the DATE: header
      let content = match[0].replace(header, '').trim();
      result.push(content); // Add the extracted date to the result array
    } else {
      result.push(0); // Add 0 if the DATE: header is not found
    }
  });

  return result; // Return the array of dates or 0s
}

// Global Constants ***************************************************************************************************************
export const client = createThirdwebClient({
  clientId: '8e6d75075256fc13dce69e13e7bb76f7',
});

export const wallets = [
  walletConnect(),
  createWallet("io.metamask"),
  createWallet("com.coinbase.wallet"),
  createWallet("com.binance"),
  inAppWallet({
    auth: {
      mode: "redirect",
      options: [
        "email",
        "google",
        "x",
        "telegram",
        "facebook",
        "discord",
        "apple",
        "phone",
      ],
    },
  }),
];

// Contracts **************************************************************************************************************
// get B.R.A.I.N contract
const contractBrain0 = getContract({
  // the client you have created via `createThirdwebClient()`
  client,
  // the chain the contract is deployed on
  chain: network[0],
  // the contract's address
  address: brainAddresses[0],
  // OPTIONAL: the contract's abi
  abi: contracts.Brain.abi,
});

const contractBrain1 = getContract({
  // the client you have created via `createThirdwebClient()`
  client,
  // the chain the contract is deployed on
  chain: network[1],
  // the contract's address
  address: brainAddresses[1],
  // OPTIONAL: the contract's abi
  abi: contracts.Brain.abi,
});

const contractBrain2 = getContract({
  // the client you have created via `createThirdwebClient()`
  client,
  // the chain the contract is deployed on
  chain: network[2],
  // the contract's address
  address: brainAddresses[2],
  // OPTIONAL: the contract's abi
  abi: contracts.Brain.abi,
});

const contractBrain3 = getContract({
  // the client you have created via `createThirdwebClient()`
  client,
  // the chain the contract is deployed on
  chain: network[3],
  // the contract's address
  address: brainAddresses[3],
  // OPTIONAL: the contract's abi
  abi: contracts.Brain.abi,
});

export const contractsBrain = [contractBrain0, contractBrain1, contractBrain2, contractBrain3];

const contractBRAINS0 = getContract({
  // the client you have created via `createThirdwebClient()`
  client,
  // the chain the contract is deployed on
  chain: network[0],
  // the contract's address
  address: brainNFTaddresses[0],
  // OPTIONAL: the contract's abi
  abi: contracts.BrainsNFT.abi,
});

const contractBRAINS1 = getContract({
  // the client you have created via `createThirdwebClient()`
  client,
  // the chain the contract is deployed on
  chain: network[1],
  // the contract's address
  address: brainNFTaddresses[1],
  // OPTIONAL: the contract's abi
  abi: contracts.BrainsNFT.abi,
});

const contractBRAINS2 = getContract({
  // the client you have created via `createThirdwebClient()`
  client,
  // the chain the contract is deployed on
  chain: network[2],
  // the contract's address
  address: brainNFTaddresses[2],
  // OPTIONAL: the contract's abi
  abi: contracts.BrainsNFT.abi,
});

const contractBRAINS3 = getContract({
  // the client you have created via `createThirdwebClient()`
  client,
  // the chain the contract is deployed on
  chain: network[3],
  // the contract's address
  address: brainNFTaddresses[3],
  // OPTIONAL: the contract's abi
  abi: contracts.BrainsNFT.abi,
});

export const contractsBRAINS = [contractBRAINS0, contractBRAINS1, contractBRAINS2, contractBRAINS3];

export const decimals = 10 ** 18;
let blockchain;

export function Connector (_counter) {
  blockchain = useSelector(selectBlockchain);
  return (
    <ConnectButton className="connector"
      client={client}
      chain={network[_counter]}
      wallets={wallets}
      theme={darkTheme({
        colors: {
          primaryText: "cyan",
          secondaryText: "gray",
          connectedButtonBg: "darkblue",
          connectedButtonBgHover: "darkslategray",
          separatorLine: "gray",
          primaryButtonBg: "cyan",
        },
      })}
        supportedTokens={{
          [blockchain.chainId]: [{
            address: `${blockchain.brainaddress}`,
            name: "B.R.A.I.N on Sonic",
            symbol: "BRAIN",
            icon: "https://i.imgur.com/JuafYAq.png",
          }]
        }}
        connectButton={{ label: "Connect" }}
        connectModal={{
          size: "wide",
          title: "Sign in to your B.R.A.I.N",
          titleIcon:
            "https://i.imgur.com/JuafYAq.png",
          welcomeScreen: {
            title: "The B.R.A.I.N on Sonic",
            subtitle:
              "Precision AI insights in Big Data for SME startups",
            img: {
              src: "https://i.imgur.com/HugRTR6.png",
              width: 250,
              height: 250,
            },
          },
        }}
      />     
  );
}

function Brain () {
    const [activeIndex, setActiveIndex] = useState(null);
    const [submitText, setSubmitText] = useState('...thinking...');
    const [loading, setLoading] = useState(false);
    const [robot, setRobot] = useState(false);
    // const [soundtrack, setSoundtrack] = useState(bgmusic.Soundtrack);

    const buildRobot = () => {
      setSubmitText('...fetching machine builds');
      setLoading(true);
      setTimeout(() => {
        setSubmitText('Error...feature not yet released.');
        setRobot(true);
      }, 7000);

      setTimeout(() => {
        setLoading(false);
      }, 14000);
    }; //buildRobot

    useEffect(() => {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 7000);
    }, []);
  return (
    <div className="brain-placeholder">
      {loading ? 
        <>{submitText}</> 
      : 
        <div className="ai-button" onClick={buildRobot}>Work Your <br /> 
          <span style={{ color: "cyan", fontSize: "3vh", textShadow: "0 0 5px goldenrod"}}>B.R.A.I.N</span>
        </div>
      }
      {robot && <Robot />}
    </div>
  );
};

export default Brain;